
import { Component, OnInit, Inject } from '@angular/core';
import { LoginService } from '../login.service';
import { LoginSettings } from '../LoginSetting.model';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StudentResetPasswordWarningComponent } from './student-reset-password-warning/student-reset-password-warning.component';
import { ForgotUsernameComponent } from '../forgot-username/forgot-username.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
    forgotUsernameDialogRef: MatDialogRef<ForgotUsernameComponent, any>;
    studentResetPasswordWarningDialogRef: MatDialogRef<StudentResetPasswordWarningComponent, any>;
    loginSettings: LoginSettings;
    forgotPassword: any = { userName: '', errorMessage: '' };
    forgotUserName: any = {};
    isProcessBusy: boolean;
    classicSetPassword: boolean;
    userType: number;
    forgotPasswordForm: FormGroup;
    formErrors: boolean;

    constructor(
        private loginService: LoginService,
        private router: Router,
        private dialogRef: MatDialogRef<ForgotPasswordComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    ngOnInit() {
        this.loginSettings = this.loginService.LoginSettings;
        this.forgotPasswordForm = new FormGroup({
            'userName': new FormControl(null, [
                Validators.required
            ]),
            'emailAddress': new FormControl(null, [
                Validators.required
            ])
        });
        if (this.data != null) {
            this.userType = this.data.userType;
        }
    }


    forgotUserNameClick() {
        this.forgotUserName = [];
        this.forgotUsernameDialogRef = this.dialog.open(ForgotUsernameComponent, {
            panelClass: 'tyl-mat-dialog',
            maxWidth: '400px',
            disableClose: true
        });
        this.forgotUsernameDialogRef.componentInstance.userType = this.userType;

        this.forgotUsernameDialogRef.afterClosed().subscribe(result => {
            if (result.isEmailSent == true) {
                this.dialogRef.close('Cancel was clicked.');
            }
        });
    }

    continueClick() {
        if (this.loginSettings.V10) {
            // V10
            this.forgotPassword.userName = this.userName.value;
        } else {
            // V9
            if (this.userType == 2) {
                // if parent
                this.forgotPassword.userName = this.emailAddress.value;
            } else {
                // else
                this.forgotPassword.userName = this.userName.value;
            }
        }
        if (this.forgotPassword.userName == undefined) {
            this.formErrors = true;
        }
        if (this.isProcessBusy == null || this.isProcessBusy == false) {
            this.isProcessBusy = true;
            if ((this.loginSettings.V10) && (this.userName.value == null || this.forgotPassword.userName.trim() == '')) {
                this.isProcessBusy = false;
            }
            else if ((!this.loginSettings.V10) && ((this.userName.value == null && this.emailAddress.value == null) || this.forgotPassword.userName.trim() == '')) {
                this.isProcessBusy = false;
            }
            else {
                const setPassword = this.classicSetPassword != null ? this.classicSetPassword : false;
                this.loginService.sendForgetPasswordEmail(this.forgotPassword.userName, this.userType, setPassword).subscribe(
                    (results: string) => {
                        this.forgotPassword.errorMessage = '';
                        this.forgotPassword.isEmailSent = true;
                        this.saveUserLoginInfo(-1);
                        if (results == 'Student cannot change their passwords') {
                            this.studentResetPasswordWarningDialogRef = this.dialog.open(StudentResetPasswordWarningComponent, {
                                panelClass: 'tyl-mat-dialog',
                                maxWidth: '400px'
                            });

                            this.studentResetPasswordWarningDialogRef.afterClosed().subscribe(result => {
                                if (result == 'Cancel was clicked.') {
                                    this.dialogRef.close('Cancel was clicked.');
                                }
                            });
                        }
                        else if (results != '' && results != 'Email Sent') {
                            this.forgotPassword.errorMessage = results;
                        }
                    },
                    (err) => {
                        this.isProcessBusy = false;
                    },
                    () => {
                        this.isProcessBusy = false;
                    });

            }
        }
    }

    cancelClick() {
        if (this.router.url == '/loginassist') {
            this.router.navigateByUrl('/login');
        }
        this.dialogRef.close('Cancel was clicked.');
    }

    saveUserLoginInfo(userId: number) {
        this.loginService.saveUserLoginInfo(userId, this.userType, window.innerHeight, window.innerWidth, 3, '');
    }

    get userName() {
        return this.forgotPasswordForm.get('userName');
    }

    get emailAddress() {
        return this.forgotPasswordForm.get('emailAddress');
    }

}
